import { isPlatformBrowser } from '@angular/common';
import { Component, DoCheck, HostListener, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { Placement } from '@popperjs/core';
@Component({
  selector: 'app-summary-bar',
  templateUrl: './summary-bar.component.html'
})
export class SummaryBarComponent implements OnInit, DoCheck {
  hasDefaultExpanded = true as boolean;
  hasLabel = true as boolean;
  hasMetaData = true as boolean;
  hasLink = true as boolean;
  hasToggle = true as boolean;
  hasLableIcon = true as boolean;
  hasTooltip = true as boolean;
  label = 'Info' as string;
  collapseLabel = 'Hide Summary';
  expandLabel = 'Show Summary';
  toggleNgModel: boolean = true;
  nextIconClass = 'icon-link-external';
  link1: { label: string, hyperLink: string, target: string } = { label: 'Link label', hyperLink: 'https://www.macmillaneducationeverywhere.com/terms-conditions/', target: '_blank' };
  selectedPlacement: Placement = 'auto';
  selectedLanguage: string = 'English';
  hasCaret: boolean = true;
  message: string = 'Summary bar info';
  metaData = ['info','info','info','info'];
  isBrowser: boolean;
  toggleText = 'Label' as string;
  isMobileView = false as boolean;
  constructor(@Inject(PLATFORM_ID) public platformId:object) { 
    if (isPlatformBrowser(this.platformId)) {
      this.isBrowser = true;
    } else{
      this.isBrowser = false;
    }
  }
  @HostListener('window:resize', ['$event'])
  onResize() {
    if (isPlatformBrowser(this.platformId)) {
      if (window.innerWidth < 768) {
        this.hasDefaultExpanded = false;
        this.isMobileView = true;
      } else{
        this.isMobileView = false;
      }
    }
  }
  ngOnInit(): void {
    this.onResize();
  }

  ngDoCheck(){
    this.toggleText =  this.toggleNgModel ? 'Label' : 'Label';
  }
}